import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SearchSection } from './components/SearchSection';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1733329941053749');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3ud1g7bihxsbo">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1733329941053749&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="3udkos1m9b4d1" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-ivory text-navy" data-id="element-2" data-mp="86w60tbxma1d">
        <main data-id="element-3" data-mp="3gkl6xsz04y2b">
          <Hero data-id="element-4" data-mp="3gm65dtoft15g" />
          <ProblemSection data-id="element-5" data-mp="3glny8208l2ir" />
          <SearchSection data-id="element-6" data-mp="3bmbf9schkflg" />
          <SystemSection data-id="element-7" data-mp="3bn2ys4st6mvd" />
          <ModulesSection data-id="element-8" data-mp="3bnuurgqbimm6" />
          <PreviewCarousel data-id="element-9" data-mp="3bk736n4foaa3" />
          <BonusSection data-id="element-10" data-mp="3qaxuzv60z9d7" />
          <DifferentiatorSection data-id="element-11" data-mp="3qc950cq2ddcr" />
          <Offer data-id="element-12" data-mp="3qdaienujybxn" />
          <Guarantee data-id="element-13" data-mp="3lkhdnzz333lk" />
          <Testimonials data-id="element-14" data-mp="3ljxukfxp695y" />
          <FAQ data-id="element-15" data-mp="3ljpi2p5hl5va" />
          <FinalCTA data-id="element-16" data-mp="3lj6ao2dgpzvi" />
        </main>
        <Footer data-id="element-17" data-mp="2xuwr773q1o7j" />
        {showPurchasePopup && <PurchaseToast data-id="element-18" data-mp="2xtv8qhkdlzfs" />}
      </div>
    </>;
}